/** Admin AI assistant: feature-flag gate around the widget. See ./README.md. */
import React from 'react';

import { useIsAdminAiAssistantAvailable } from '@/modules/featureFlags';

import AssistantWidget from './components/AssistantWidget/AssistantWidget';

interface Props {
  /** Full name of the participant whose page is open. */
  participantName?: string;
}

/**
 * Shown only when the Unleash flag is on and the participant has loaded (the agent
 * finds the participant by name).
 */
const Assistant: React.FC<Props> = ({ participantName }) => {
  const isEnabled = useIsAdminAiAssistantAvailable();
  if (!isEnabled || !participantName) return null;
  return <AssistantWidget participantName={participantName} />;
};

export default Assistant;
